import angular from 'angular';
import '../../services/reception';

const module = angular.module('whyline.controllers.reception-welcome', [
  'whyline.services.reception',
]);

const ReceptionWelcomeController = (ReceptionService, $scope, currentPlace, $state) => {
  /*@ngInject*/

  $scope.isWhylineEnterprise = currentPlace.enterpriseType === 'whyline';

  $scope.currentPlaceId = $state.params.placeId;

  ReceptionService.SetButtonStatus('both', false);
  ReceptionService.SetButtonStatus('status-text', false);
};

module.exports = module.controller('ReceptionWelcomeController', ReceptionWelcomeController);
